PopOver = require 'views/lib/pop-over'
template = require 'views/templates/popover_set_list_limit'
Util = require 'lib/util'
View = require 'view'
trackUe = require 'debug/trackUe'
{ Noun, Verb } = require 'common/debug/analytics-constants'

LIST_LIMITS_POWER_UP_ID = require 'data/list-limits-power-up-id'
WIP_LOWER_LIMIT = 0
WIP_UPPER_LIMIT = 5000

isValidListLimit = (value) ->
  return value == null || (!isNaN(value) && value >= WIP_LOWER_LIMIT && value <= WIP_UPPER_LIMIT)

module.exports = class ListMoveView extends View
  viewTitleKey: 'set list limit'

  tagName: 'form'

  events:
    'click .js-submit': 'submit'
    'submit': 'submit'
    'click .js-remove-limit': 'removeLimit'
    'keyup .js-list-limit-input': 'limitChanged'

  getValue: ->
    valueString = @$('.js-list-limit-input').val()

    if !valueString.length
      return null

    return parseInt(valueString)

  limitChanged: (e) ->
    value = @getValue()
    isValid = isValidListLimit(value)

    @$('.js-list-limit-input').toggleClass('is-invalid', !isValid)
    @$('.js-submit').attr('disabled', !isValid)

  submit: (e) ->
    Util.stop(e)

    value = @getValue()

    if isValidListLimit(value)
      trackUe(Noun.LIST_LIMIT_MENU, Verb.SETS, Noun.LIST_LIMIT, '', '', 'by clicking the save button', { change: value })
      @model.setSoftLimit(value)
      PopOver.hide()

  removeLimit: (e) ->
    Util.stop(e)
    trackUe(Noun.LIST_LIMIT_MENU, Verb.REMOVES, Noun.LIST_LIMIT, '', '', 'by clicking the remove button')
    @model.setSoftLimit(null)
    PopOver.hide()

  render: ->
    view = @
    model = view.model

    data =
      limit: model.get('softLimit')

    @$el.html(
      template(data)
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/list/list-set-limit-view.coffee